import PageRoutes from "./routes/PageRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useNotificationSocket from "./hooks/useNotificationSocket"; // update path as needed
const App = () => {
    const { emitDelete } = useNotificationSocket();
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        closeOnClick
        draggable
        pauseOnHover
        theme="light"
      />
      <PageRoutes emitDelete={emitDelete} />
    </>
  );
};

export default App;
